import axios from "axios";
import { UserSession } from "../user_session";
import * as Vars from "./Vars";

export class Projects {

  //Loading all the projects for the dashboard
  static async load(){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "GET",
        params: {
          _console_token: UserSession.token
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async get(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "GET",
        params: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async create(name){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "POST",
        data: {
          _console_token: UserSession.token,
          name: name
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async edit(id, name, description){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "PUT",
        data: {
          _console_token: UserSession.token,
          id: id,
          name: name,
          description: description
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }

  static async delete(id){
    return new Promise((resolve) => {
      axios({
        url: Vars.API_ENDPOINT + "/console_api/v1/project/",
        method: "DELETE",
        data: {
          _console_token: UserSession.token,
          id: id
        }
      }).then(function(data){
        resolve(data.data);
      });
    });
  }
}
